import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useApi, useAuth } from '../../hooks';
import type { UserBlockFood } from '../../models/suspectIdentificationBlockData';

type Props = {
  enabled?: boolean;
  userBlockId?: string;
};

export const useUserBlockFoods = ({
  enabled = true,
  userBlockId,
}: Props = {}) => {
  const { patient: userId } = useParams();
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchUserBlockFoods = async (): Promise<UserBlockFood[]> => {
    return await api({
      route: `/private/user/blocks/${userBlockId}/foods`,
      token: userToken,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Coach-Override': userId ?? '',
      },
    });
  };

  const { data, isLoading, isError } = useQuery<UserBlockFood[], Error>({
    queryKey: ['user-block-foods', userToken, userId, userBlockId],
    queryFn: fetchUserBlockFoods,
    enabled:
      enabled &&
      isAuthenticated &&
      !loading &&
      !!userToken &&
      !!userId &&
      !!userBlockId,
    refetchOnWindowFocus: false,
  });

  return {
    foods: data ?? [],
    isLoading,
    isError,
  };
};
